import { useEffect } from "react";
import api from "@/lib/appApi";

function setMeta(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo() {
  useEffect(() => {
    api.get("/seo").then(({ data }) => {
      if (data.title) document.title = data.title;
      setMeta("name", "description", data.description);
      setMeta("name", "keywords", data.keywords);
      setMeta("name", "robots", data.robots_index ? "index, follow" : "noindex, nofollow");
      setMeta("property", "og:title", data.og_title);
      setMeta("property", "og:description", data.og_description);
      setMeta("property", "og:image", data.og_image);
      setMeta("name", "twitter:title", data.og_title);
      setMeta("name", "twitter:description", data.og_description);
      setMeta("name", "twitter:image", data.og_image);
    }).catch(() => {});
  }, []);
  return null;
}
